/* eslint-disable no-unused-vars */
import TabContext from '@material-ui/lab/TabContext'
import { GeneralFilters } from 'components/GeneralFilters'
import { Base } from 'layouts'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { propertiesDetailsActions } from 'store/PropertiesDetails'
import { all } from 'store/PropertiesDetails/PropertiesDetails.selector'
import { all as allFilter } from 'store/TraceabilityTables/TraceabilityTables.selector'
import { InlinePropertyFilter } from './PropertyInlineFilter'
import { ProprietyTab } from './ProprietyTab'
import * as S from './styled'

export function Properties() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { filters } = useSelector(allFilter)

  const [filter] = useState({
    ...filters,
    trackable: 'true',
    typeVisible: 'all',
    limit: 50
  })
  const { kpiPropertiesSummary } = useSelector(all)

  useEffect(() => {
    if (filters.begin && filters.end) {
      dispatch(propertiesDetailsActions.cleanPropertiesDetails())
      dispatch(
        propertiesDetailsActions.getKpisPropertiesSummary({
          ...filters,
          limit: filter.limit,
          years: filters.years.length
            ? filters.years
            : [new Date().getFullYear()]
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  return (
    <Base>
      <GeneralFilters
        InlineFilter={InlinePropertyFilter}
        showInlineFilters={false}
        filterType="properties"
      />
      <TabContext value="properties" aria-label="simple tabs example">
        <S.TabList>
          <S.Tab
            data-tip="tooltip_loading"
            label={t('common:properties')}
            value="properties"
          />
        </S.TabList>
        <S.Panel value="properties">
          <ProprietyTab kpiPropertiesSummary={kpiPropertiesSummary} />
        </S.Panel>
      </TabContext>
    </Base>
  )
}
